
import React from "react";

// import './404.scss';
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * A functional component that renders a 404 page not found error page.
 * @param {object} props - The props passed to the component.
 * @returns The JSX code for the 404 page.
 */
const Pages404 = (props) => {
  
  const { t } = useTranslation();

  const CLOUDINARY_URL =
  process.env.REACT_APP_CLOUDNARY_URL +
  process.env.REACT_APP_CLOUDNARY_NAME +
  process.env.REACT_APP_CLOUDNARY_SUBFLODER;

  return (
    /**
     * Renders a page for when a requested page is not found.
     * @returns {React.Fragment} - The rendered page component.
     */
    <React.Fragment>
      <div className="account-pages nofoundPage">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="text-center d-flex justify-content-center pageNotFoundLogo">
              <img src={CLOUDINARY_URL + "Logo.png"} alt="App Logo" className="img-fluid" />
            </Col>
            <br />
            <h1 className="text-center text-primary text-notfound"> {t("PAGE_NOT_FOUND")}</h1>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}


export default Pages404;